export default "__VITE_ASSET__Dq90HHr2__"